import React, { useEffect, useState, useRef } from "react";
import SubmitArrow from "../Popup/SubmitArrow";

const EmbeddedEmailSignup = ({ blok }) => {
  const [hasSubmitted, setHasSubmitted] = useState(false);

  const formRef = useRef(null);

  const handleSubmit = (e) => {
    e.preventDefault();
    let myForm = formRef.current;
    let formData = new FormData(myForm);
    fetch("/api/mailchimp", {
      method: "POST",
      body: JSON.stringify(Object.fromEntries(formData)),
    })
      .then(() => console.log("Form successfully submitted")
      
      )
      .catch((error) => alert(error));
    setHasSubmitted(true);
    setShowPopup(false);
  };

  return (
    <section className="space-y-6 pt-14 not-prose">
      {blok.title != "" && blok.title != undefined && (
        <h2 className="text-sm lg:text-3xl font-[500] not-prose">{blok.title}</h2>
      )}
      <form

        className="flex border border-green w-full on-page-embedded-email-signup"
        onSubmit={handleSubmit}
        ref={formRef}
        method="post"
        name="edm"
      >
        <input
          type="text"
          placeholder="Your email"
          className="appearance-none text-xs lg:text-lg bg-white flex-shrink lg:flex-grow h-[3.125rem] border-0 w-full px-4"
          name="email"
          type="email"
          required
        />
        <button className="bg-green px-5" disabled={hasSubmitted}>
          <SubmitArrow className="w-5 lg:w-8" />
          <span className="sr-only">Submit</span>
        </button>
        <p className="hidden">
          <label>
            Don’t fill this out if you’re human: <input name="honey-field" />
          </label>
        </p>
      </form>
      {hasSubmitted && (
        <p className="text-black text-sm lg:text-lg underline font-semibold">
          Thank you for subscribing!
        </p>
      )}
    </section>
  );
};

export default EmbeddedEmailSignup;
